import { Box, Grid, Typography, Divider } from "@mui/material";
import IncomingMailFlow from "./IncomingMailFlow";
import OutgoingMailFlow from "./OutgoingMailFlow";

const MailFlowDisplay = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, whiteSpace: "nowrap" }}>
          Active Mail Flow Tests
        </Typography>
        <Divider sx={{ flexGrow: 1 }} />
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <OutgoingMailFlow />
        </Grid>
        <Grid item xs={12} md={6}>
          <IncomingMailFlow />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MailFlowDisplay;
